import { useEffect, useRef, useState } from 'react'

// ดึงข้อมูลแบบ debounce + กัน race (stale-guard) + สถานะ loading สำหรับ overlay
// - fetcher: ฟังก์ชันคืน Promise (อ่านค่าตัวกรองล่าสุดจาก closure)
// - depKey : string/primitive ที่เปลี่ยนเมื่อค่าตัวกรองเปลี่ยน (ใช้เป็น dependency ของ effect)
// - enabled: gate — ยังไม่ยิงจนกว่าจะพร้อม (เช่น รอ profile/สิทธิ์); ค่าเริ่มต้น true
// - delay  : เวลา debounce (ms) รวบการติ๊ก multi-select หลายครั้งเป็น request เดียว
// หมายเหตุ: โหลด "ครั้งแรก" ยิงทันที (delay 0) ไม่หน่วง แล้ว debounce เฉพาะการเปลี่ยนตัวกรองครั้งถัดไป
export default function useDebouncedResource(fetcher, depKey, enabled = true, delay = 800) {
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(false)
    const [loadedOnce, setLoadedOnce] = useState(false)

    // เก็บ fetcher ล่าสุดไว้ใน ref เพื่อให้ตอน timer ยิงใช้ค่าตัวกรองล่าสุดเสมอ
    const fetcherRef = useRef(fetcher)
    fetcherRef.current = fetcher
    const hasRunRef = useRef(false)   // เคยยิงจริงไปแล้วหรือยัง (แยกครั้งแรกออกจากการเปลี่ยนตัวกรอง)

    useEffect(() => {
        if (!enabled) return
        let cancelled = false                       // stale-guard: effect นี้ถูกแทนที่แล้วหรือยัง
        const effectiveDelay = hasRunRef.current ? delay : 0   // ครั้งแรกไม่หน่วง
        hasRunRef.current = true
        setLoading(true)                            // แจ้งกำลังโหลดทันที (ครอบช่วง debounce ด้วย)
        const timer = setTimeout(async () => {
            const result = await fetcherRef.current()
            if (cancelled) return                   // ตัวกรองเปลี่ยนระหว่างรอ response → ทิ้งผลเก่า
            setData(result)
            setLoading(false)
            setLoadedOnce(true)
        }, effectiveDelay)
        return () => { cancelled = true; clearTimeout(timer) }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [enabled, depKey, delay])

    return { data, loading, loadedOnce }
}
